<template>
  <div
    class="form-group"
    :class="[
      {'input-group': hasIcon},
      {'has-danger': error},
      {'input-group-focus': focused},
      {'has-label': label || $slots.label}]"
  >
    <slot name="label">
      <label
        v-if="label"
        :class="labelClasses"
      >
        {{ label }}
        <span v-if="required">*</span>
        <span
          v-if="note"
          v-popover:popover1
          type="primary"
          size="sm"
          icon
        >
          <sup><i class="fa fa-info-circle" /></sup>
        </span>
        <el-popover
          ref="popover1"
          popper-class="popover popover-primary fcx-popover"
          placement="right"
          width="200"
          trigger="hover"
        >
          <h3 class="popover-header">
            {{note.title}}
          </h3>
          <div class="popover-body" v-html="note.content" />
        </el-popover>
      </label>
    </slot>

    <slot name="addonLeft">
      <div
        v-if="addonLeftIcon"
        class="input-group-prepend"
      >
        <i
          class="input-group-text"
          :class="addonLeftIcon"
        />
      </div>
    </slot>
    <slot>
      <input
        :value="value"
        v-bind="$attrs"
        :required="required?'required':''"
        class="form-control"
        :class="[{valid: value && !error}, inputClasses]"
        aria-describedby="addon-right addon-left"
        v-on="listeners"
      >
    </slot>
    <slot name="addonRight">
      <span
        v-if="addonRightIcon"
        class="input-group-addon input-group-append"
      >
        <i
          class="input-group-text"
          :class="addonRightIcon"
        />
      </span>
    </slot>

    <slot name="infoBlock" />
    <slot name="helpBlock">
      <div
        v-if="error"
        class="text-danger invalid-feedback"
        style="display: block;"
        :class="{'mt-2': hasIcon}"
      >
        {{ error }}
      </div>
    </slot>
  </div>
</template>
<script>
  import {Popover} from 'element-ui';
  export default {
    name: 'FgInput',
    inheritAttrs: false,
    components: {
      [Popover.name]: Popover
    },
    props: {
      required: Boolean,
      label: String,
      error: String,
      labelClasses: String,
      inputClasses: String,
      value: {
        type: [String, Number],
        default: ''
      },
      addonRightIcon: String,
      addonLeftIcon: String,
      note: {
        type: Object,
        required: false
      }
    },
    data() {
      return {
        focused: false
      }
    },
    computed: {
      listeners() {
        return {
          ...this.$listeners,
          input: this.updateValue,
          focus: this.onFocus,
          blur: this.onBlur
        }
      },
      hasIcon() {
        const {addonRight, addonLeft} = this.$slots;
        return addonRight !== undefined || addonLeft !== undefined || this.addonRightIcon !== undefined || this.addonLeftIcon !== undefined
      }
    },
    methods: {
      updateValue(evt) {
        let value = evt.target.value;
        this.$emit('input', value);
      },
      onFocus(value){
        this.focused = true;
        this.$emit('focus', value);
      },
      onBlur(value){
        this.focused = false;
        this.$emit('blur', value);
      }
    }
  }
</script>
<style>

</style>
